var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 57,
    viewBox: "0 0 182 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.257 57H6.74322C3.02675 57 0 53.7875 0 49.875V7.125C0 3.19825 3.02675 0 6.74322 0H175.257C178.97 0 182 3.19825 182 7.125V49.875C182 53.7875 178.97 57 175.257 57Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4714 20.2091C94.3626 20.2091 93.4278 19.8211 92.6886 19.0574C91.9555 18.3151 91.5462 17.2917 91.5645 16.2469C91.5645 15.1319 91.9433 14.188 92.6886 13.4395C93.4248 12.6758 94.3595 12.2878 95.4683 12.2878C96.5649 12.2878 97.4996 12.6758 98.251 13.4395C98.9964 14.2124 99.3751 15.1564 99.3751 16.2469C99.3629 17.365 98.9841 18.309 98.251 19.0544C97.5149 19.8242 96.5802 20.2091 95.4714 20.2091ZM62.4788 20.2091C61.3944 20.2091 60.4536 19.8272 59.6838 19.0727C58.9202 18.3212 58.5322 17.3711 58.5322 16.25C58.5322 15.1289 58.9202 14.1788 59.6838 13.4273C60.4383 12.6728 61.3791 12.2909 62.4788 12.2909C63.0164 12.2909 63.5387 12.3978 64.0396 12.6147C64.5314 12.8255 64.9316 13.1127 65.2279 13.464L65.3012 13.5526L64.4734 14.3651L64.3879 14.2643C63.9205 13.7084 63.2943 13.4365 62.4665 13.4365C61.7273 13.4365 61.0828 13.6992 60.5513 14.2185C60.0168 14.7409 59.7449 15.4252 59.7449 16.2531C59.7449 17.0809 60.0168 17.7652 60.5513 18.2876C61.0828 18.8069 61.7273 19.0696 62.4665 19.0696C63.2546 19.0696 63.9175 18.8069 64.4337 18.2876C64.7391 17.9821 64.9285 17.5544 64.9957 17.0137H62.3413V15.8712H66.1351L66.1504 15.9751C66.1779 16.1675 66.2054 16.3661 66.2054 16.5494C66.2054 17.6033 65.8877 18.4556 65.2584 19.0849C64.5437 19.8303 63.609 20.2091 62.4788 20.2091ZM106.346 20.0472H105.176L101.593 14.3132L101.623 15.3458V20.0441H100.453V12.4528H101.788L101.825 12.5108L105.194 17.9118L105.164 16.8824V12.4528H106.346V20.0472ZM86.6803 20.0472H85.4951V13.5953H83.4393V12.4528H88.7329V13.5953H86.6772V20.0472H86.6803ZM82.4741 20.0472H81.292V12.4528H82.4741V20.0472ZM75.8304 20.0472H74.6482V13.5953H72.5925V12.4528H77.8861V13.5953H75.8304V20.0472ZM71.8441 20.035H67.3111V12.4528H71.8441V13.5953H68.4963V15.6787H71.5173V16.809H68.4963V18.8925H71.8441V20.035ZM93.5561 18.2723C94.0846 18.8008 94.726 19.0666 95.4714 19.0666C96.2381 19.0666 96.8643 18.8069 97.3866 18.2723C97.9059 17.753 98.1686 17.0718 98.1686 16.25C98.1686 15.4282 97.9059 14.744 97.3896 14.2277C96.8612 13.6992 96.2167 13.4334 95.4744 13.4334C94.7077 13.4334 94.0815 13.6931 93.5623 14.2277C93.043 14.747 92.7803 15.4282 92.7803 16.25C92.7803 17.0718 93.0399 17.756 93.5561 18.2723Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4543 30.6507C88.5678 30.6507 86.2279 32.841 86.2279 35.8623C86.2279 38.856 88.583 41.0739 91.4543 41.0739C94.3409 41.0739 96.6807 38.8682 96.6807 35.8623C96.6807 32.841 94.3409 30.6507 91.4543 30.6507ZM91.4543 39.0088C89.8751 39.0088 88.5158 37.7013 88.5158 35.85C88.5158 33.9713 89.8782 32.6913 91.4543 32.6913C93.0336 32.6913 94.3929 33.9713 94.3929 35.85C94.3959 37.7135 93.0336 39.0088 91.4543 39.0088ZM80.0516 30.6507C77.165 30.6507 74.8251 32.841 74.8251 35.8623C74.8251 38.856 77.1802 41.0739 80.0516 41.0739C82.9381 41.0739 85.278 38.8682 85.278 35.8623C85.278 32.841 82.9351 30.6507 80.0516 30.6507ZM80.0516 39.0088C78.4723 39.0088 77.113 37.7013 77.113 35.85C77.113 33.9713 78.4754 32.6913 80.0516 32.6913C81.6308 32.6913 82.9901 33.9713 82.9901 35.85C82.9901 37.7135 81.6308 39.0088 80.0516 39.0088ZM66.4831 32.2422V34.4479H71.7767C71.6148 35.6851 71.2055 36.5985 70.5793 37.2247C69.8034 38.0007 68.606 38.8438 66.4953 38.8438C63.2421 38.8438 60.6977 36.2166 60.6977 32.9632C60.6977 29.7098 63.2421 27.0826 66.4953 27.0826C68.2517 27.0826 69.5315 27.776 70.4815 28.6619L72.0455 27.0979C70.7259 25.8331 68.9695 24.8647 66.5075 24.8647C62.0447 24.8647 58.2998 28.5 58.2998 32.951C58.2998 37.4141 62.0417 41.0372 66.5075 41.0372C68.9176 41.0372 70.7259 40.249 72.1554 38.7644C73.6125 37.3072 74.0737 35.2513 74.0737 33.5925C74.0737 33.0762 74.034 32.6119 73.9515 32.2178H66.48C66.4831 32.2147 66.4831 32.2422 66.4831 32.2422ZM121.982 33.9591C121.545 32.7891 120.226 30.6384 117.519 30.6384C114.837 30.6384 112.607 32.7493 112.607 35.85C112.607 38.7766 114.813 41.0616 117.779 41.0616C120.161 41.0616 121.548 39.6045 122.119 38.7491L120.351 37.5638C119.764 38.4345 118.949 39.0057 117.791 39.0057C116.621 39.0057 115.802 38.4742 115.259 37.4263L122.226 34.5395C122.226 34.5426 121.982 33.9591 121.982 33.9591ZM114.877 35.7003C114.822 33.6872 116.441 32.6638 117.599 32.6638C118.512 32.6638 119.273 33.1129 119.532 33.7666L114.877 35.7003ZM109.217 40.75H111.505V25.4391H109.217V40.75ZM105.46 31.8085H105.377C104.861 31.1944 103.88 30.6384 102.628 30.6384C100.029 30.6384 97.6338 32.9265 97.6338 35.8653C97.6338 38.7919 100.016 41.0525 102.628 41.0525C103.865 41.0525 104.861 40.4934 105.377 39.8672H105.46V40.6156C105.46 42.6043 104.397 43.6766 102.683 43.6766C101.281 43.6766 100.41 42.6685 100.056 41.8253L98.0675 42.6563C98.6387 44.031 100.163 45.7325 102.68 45.7325C105.362 45.7325 107.635 44.1532 107.635 40.301V30.95H105.472V31.8085C105.475 31.8085 105.46 31.8085 105.46 31.8085ZM102.833 39.0088C101.253 39.0088 99.9339 37.6891 99.9339 35.8653C99.9339 34.0263 101.253 32.6944 102.833 32.6944C104.397 32.6944 105.609 34.0416 105.609 35.8653C105.625 37.6891 104.4 39.0088 102.833 39.0088ZM132.694 25.4391H127.224V40.75H129.511V34.9519H132.697C135.23 34.9519 137.719 33.1159 137.719 30.2016C137.719 27.2873 135.239 25.4391 132.694 25.4391ZM132.762 32.8135H129.508V27.5591H132.762C134.475 27.5591 135.444 28.9735 135.444 30.1863C135.444 31.3869 134.463 32.8135 132.762 32.8135ZM146.889 30.6232C145.227 30.6232 143.514 31.3594 142.805 32.9632L144.833 33.8063C145.27 32.9632 146.07 32.676 146.917 32.676C148.102 32.676 149.299 33.3848 149.327 34.6495V34.8114C148.917 34.5792 148.019 34.2248 146.944 34.2248C144.754 34.2248 142.533 35.4224 142.533 37.6677C142.533 39.7236 144.329 41.0433 146.33 41.0433C147.867 41.0433 148.713 40.3499 149.241 39.5464H149.324V40.7317H151.529V34.8664C151.529 32.1353 149.501 30.6232 146.889 30.6232ZM146.602 39.0088C145.854 39.0088 144.806 38.6422 144.806 37.7013C144.806 36.516 146.113 36.0669 147.228 36.0669C148.236 36.0669 148.713 36.2838 149.311 36.5832C149.146 37.9579 147.986 38.9965 146.602 39.0088ZM159.575 30.95L156.948 37.5913H156.865L154.144 30.95H151.682L155.766 40.2338L153.438 45.3934H155.821L162.104 30.95H159.575ZM138.981 40.75H141.269V25.4391H138.981V40.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7807 13.2287C20.4263 13.6106 20.2217 14.1941 20.2217 14.9578V42.0452C20.2217 42.809 20.4263 43.3924 20.7929 43.759L20.8876 43.8415L36.0628 28.6649V28.3259L20.8754 13.1462L20.7807 13.2287Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1118 33.7392L36.0503 28.6773V28.3229L41.1118 23.261L41.2217 23.3282L47.2087 26.7313C48.9223 27.6966 48.9223 29.2913 47.2087 30.2688L41.2217 33.672L41.1118 33.7392Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2216 33.6719L36.0502 28.5L20.7803 43.7713C21.3393 44.37 22.277 44.4372 23.3247 43.8537L41.2216 33.6719Z",
    fill: "url(#paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2216 23.3281L23.3247 13.1615C22.277 12.5628 21.3362 12.6453 20.7803 13.244L36.0502 28.5L41.2216 23.3281Z",
    fill: "url(#paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1121 33.5619L23.3374 43.6613C22.3447 44.2325 21.4589 44.1928 20.8877 43.6735L20.793 43.7682L20.8877 43.8507C21.4589 44.367 22.3447 44.4097 23.3374 43.8385L41.2343 33.6719L41.1121 33.5619Z",
    fill: "#323961"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.2084 30.0916L41.0962 33.5619L41.2062 33.6719L47.1932 30.2688C48.0515 29.78 48.473 29.1385 48.473 28.5C48.4211 29.0865 47.9843 29.6425 47.2084 30.0916Z",
    fill: "#323961"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3251 13.3387L47.209 26.9084C47.9849 27.3452 48.4217 27.9165 48.4889 28.5C48.4889 27.8615 48.0673 27.22 47.209 26.7312L23.3251 13.1615C21.6115 12.1809 20.2217 12.9996 20.2217 14.9578V15.1349C20.2217 13.1737 21.6115 12.3703 23.3251 13.3387Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 91,
    y1: 0,
    x2: 91,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#363643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#110E17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 34.7016,
    y1: 14.6655,
    x2: 10.3932,
    y2: 21.1419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 49.4434,
    y1: 28.5001,
    x2: 19.8049,
    y2: 28.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 38.4096,
    y1: 31.3142,
    x2: 18.8926,
    y2: 64.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 16.9351,
    y1: 4.21902,
    x2: 25.6425,
    y2: 18.8884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.1e3a7e2f31f413ff53a1cf3e2904d8c5.svg";
export { ForwardRef as ReactComponent };